<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/promocodes/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <data-list-item :promocodes="promocodes" @update="fetchPromocodes" />
      <b-row v-if="numberOfPages > 0">
        <b-colxx xxs="12">
          <b-pagination-nav
            size="sm"
            :number-of-pages="numberOfPages"
            :link-gen="linkGen"
            v-model="page"
            :per-page="perPage"
            align="center"
          >
            <template v-slot:next-text>
              <i class="simple-icon-arrow-right" />
            </template>
            <template v-slot:prev-text>
              <i class="simple-icon-arrow-left" />
            </template>
            <template v-slot:first-text>
              <i class="simple-icon-control-start" />
            </template>
            <template v-slot:last-text>
              <i class="simple-icon-control-end" />
            </template>
          </b-pagination-nav>
        </b-colxx>
      </b-row>
    </template>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/Promocodes/DataList.vue'
import { handleArrayDataInternalization } from '@/utils'

export default {
  components: { DataListItem },
  data() {
    return {
      page: this.$route.query.page || 1,
      perPage: 10,
      numberOfPages: 1,
      apiBase: '/api/dashboard/promocodes'
    }
  },
  computed: {
    apiUrl() {
      return `${this.apiBase}?page=${this.page}`
    },
    promocodes() {
      const promocodes = this.$store.getters['promocodes/promocodes']
      return handleArrayDataInternalization(promocodes, ['name'], this.$i18n.locale)
    },
    isLoading() {
      return this.$store.getters['promocodes/isLoading']
    }
  },
  mounted() {
    this.fetchPromocodes()
  },
  methods: {
    linkGen(pageNum) {
      return { query: { page: pageNum } }
    },
    fetchPromocodes() {
      this.$store.dispatch('promocodes/fetchPromocodes', { vm: this })
    }
  },
  watch: {
    apiUrl() {
      this.fetchPromocodes()
    }
  }
}
</script>
